"use client";

import { useTranslate } from "./i18nContext.ts";
import type { Translate } from "./translate.ts";

/** Translates strings registered in the catalogs (see src/shared/i18n/catalog.ts). */
export function usePublicFrontendTranslation(): Translate {
  return useTranslate();
}
